import React from "react";
import { Helmet } from "react-helmet-async";
import { useShop } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";

const SITE_NAME = "IdeaMedia";

const Seo = ({ title, description, image, type = "website", noindex = false }) => {
  const { lang } = useShop();
  const { altUrls } = useLocale();
  const origin = typeof window !== "undefined" ? window.location.origin : "https://ideamedia.org";

  const fullTitle = title
    ? (title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`)
    : SITE_NAME;

  // URL localizzati reali (it/en) forniti dal LocaleProvider (o dalla detail page).
  const itUrl = `${origin}${altUrls.it}`;
  const enUrl = `${origin}${altUrls.en}`;
  const canonical = lang === "en" ? enUrl : itUrl;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex,follow" />}
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="it" href={itUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={itUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === "it" ? "it_IT" : "en_US"} />
      {image && <meta property="og:image" content={`${origin}${image}`} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
    </Helmet>
  );
};

export default Seo;
